module.exports = __webpack_public_path__ + "img/a9.fe71066b.png";